import { Component } from '@angular/core';
import { PlanthunterService } from '../../service/planthunter.service';

@Component({
    selector: 'planthunter-amountofnewhunts-component',
    styleUrls: ['planthunter.component.scss'],
    template: `@if (newHunts > 0) {
  <span class="planthunter-nav-count">{{
    newHunts
  }}</span>
}`,
    standalone: true
})
export class PlanthunterAmountOfNewHuntsComponent {
  newHunts: number = 0;

  constructor(private planthunterService: PlanthunterService) {
    this.planthunterService
      .getAmountOfNewPlanthunterItems()
      .then((amountOfNewPlanthunterItems) => {
        this.newHunts = amountOfNewPlanthunterItems;
      });
  }
}
